<script>
  export let value = "";
  export let clients = [];
  export let disabled = false;

  let isOpen = false;
  let search = "";

  $: filtered = clients.filter((c) =>
    `${c.code} ${c.namesite}`.toLowerCase().includes(search.toLowerCase()),
  );
  $: selected = clients.find((c) => String(c.id) === String(value));
</script>

<div class="select-box">
  <button
    type="button"
    class="trigger"
    on:click={() => !disabled && (isOpen = !isOpen)}
    {disabled}
  >
    {selected
      ? `${selected.code} — ${selected.namesite}`
      : "Selecciona un cliente..."}
  </button>

  {#if isOpen}
    <div class="dropdown">
      <input
        type="text"
        placeholder="Buscar..."
        bind:value={search}
      />

      <ul>
        {#each filtered as client}
          <button
            type="button"
            class="option"
            on:click={() => {
              value = String(client.id);
              isOpen = false;
              search = "";
            }}
          >
           {client.code} — {client.namesite}
          </button>
        {/each}
        {#if filtered.length === 0}
          <div class="no-results">Sin resultados</div>
        {/if}
      </ul>
    </div>
  {/if}
</div>

<style>
  .select-box {
    position: relative;
    width: 100%;
    font-family: sans-serif;
  }
  .trigger {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: white;
    text-align: left;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }
  .trigger:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
  .dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;
    margin-top: 4px;
  }
  input {
    width: 100%;
    padding: 8px;
    border: none;
    border-bottom: 1px solid #eee;
    box-sizing: border-box;
    outline: none;
  }
  ul {
    max-height: 160px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .option {
    width: 100%;
    padding: 8px 12px;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;
  }
  .option:hover {
    background: #f0f0f0;
  }
  .no-results {
    padding: 8px;
    color: #888;
    text-align: center;
    font-size: 0.9rem;
  }
</style>
